import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Main from '../page/main';
import Mail from '../page/Mail';
import Works from '../page/Works';
import Avatar from '../page/Avatar';
import Metaverse from '../page/Metaverse';
import VrchatProfile from '../page/VrchatProfile';
import Blog from '../components/Blog';
import NotFound from '../page/NotFound';

const Root = () => {
  return (
    <Routes>
      <Route path="/" element={<Main />} />
      <Route path="/mail" element={<Mail />} />
      <Route path="/works" element={<Works />} />
      <Route path="/avatar" element={<Avatar />} />
      <Route path="/metaverse" element={<Metaverse />} />
      <Route path="/vrchat" element={<VrchatProfile />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/root" element={<Blog />} />
      <Route path="/blog/:postId" element={<Blog />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Root;
